import { Card, CardContent, Button, CardActions} from '@material-ui/core';
import { useState,useEffect } from 'react';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

let token: any = localStorage.getItem('credentials')

// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

async function SwitchBetweenGateWay(params: any) {
   return await axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/paymentConfigs/${params.id}`,
        data:{onlineGateway:params.gate},
        method: "PATCH",
      });
     
     
//     const PATCH_REQUEST = gql`
//     mutation{
//         updatePaymentConfig(where:{id:"${params.id}"},data:{onlineGateway:${params.gate}}){
//           id
//           onlineGateway
//           service
//         }
//       }
//   `;
//     return client.query({
//         query: PATCH_REQUEST
//     })
}


const status: Record<string, string> = {
    PENDING: 'در انتظار پرداخت',
    FAILED: 'خطا',
    SUCCESS: 'موفق',
    CANCELED: 'لغو شده'
}

export function SwitchGateWay() {
    const [gate, setGate] = useState('');
    const [isShow,setIsShow] = useState(false);  
    const [paymentList,setPaymentList] = useState([]);
    const [selectedPayment,setSelectedPayment] = useState(null);
    useEffect(() => {
        getGateList()
      }, [])

      const  getGateList = async()=>{
          const res = await axiosWithAuthInterceptor({
              url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/paymentConfigs?where[service][equals]=LIMOOME_SHOP`,
              method: "GET",
            });
            if (!res.data.err) {
                setPaymentList(res.data)
            }  
      }
    const [serverState, setServerState] = useState({
        fetchData: { status: 'NONE', message: '' },
        submit: { status: 'NONE', message: '' }
    })

    const setGateWay = async () => {
        let params = {id:selectedPayment,gate:gate}
        SwitchBetweenGateWay(params).then((res: any) => {
                if (res.data.err) {
                    console.log('hasError');
                    getGateList()
                    setSelectedPayment(null)
                    setIsShow(!isShow)
                   
                    // let message = "";
                    // switch (res.data.err.message) {
                    //     case "payment-not-found":
                    //         message = "سفارشی با این شماره پرداخت وجود ندارد"
                    //         break;
                    //     case "payment-not-settled-yet":
                    //         message = "پرداخت موفقی برای این شماره پرداخت وجود ندارد"
                    //         break;
                    //     case "snapp-error":
                    //         message = "خطا از طرف اسنپ"
                    //         break;
                    //     default:
                    //         message = "با خطا مواجه شد"
                    //         break;
                    // }
                    // setServerState({ ...serverState, submit: { message: message, status: 'ERROR' } })
                    // document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
                }
                else {
                    getGateList()
                    setSelectedPayment(null)
                    setIsShow(!isShow)
                    setServerState({ ...serverState, submit: { message: 'با موفقیت انجام شد', status: 'SUCCESSFUL' } })
                    document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-successful')
                }
            }).catch((error => {
                getGateList()
                setSelectedPayment(null)
                setIsShow(!isShow)
                setServerState({ ...serverState, submit: { message: 'با خطا مواجه شد', status: 'ERROR' } })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
            }))
    }
const onChangeHandler = (evt:any) =>{
    setGate(evt.target.value)
}
const onClickCard = (id:any)=>{
setSelectedPayment(id)
setIsShow(!isShow)
}
    return (     
        <div>
             <div style={{ display: 'flex', alignItems: 'center', gap: '3rem' }}>
{!isShow &&

paymentList.map((item:any,index:any) => (
    <Card key={index} style={{ marginTop: '2rem',width:"400px" ,margin:"1rem"}}>
    <Card  variant="outlined">
        <CardContent>
       <div><p>درگاه آنلاین</p>  <p>{item.onlineGateway}</p> </div> 
     <div>  <p>سرویس</p> <p>{item.service}</p> </div>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary" onClick={(e) =>onClickCard(item.id)} >تغییر درگاه آنلاین</Button>
        </CardActions>
      </Card>
      </Card>
)
)
 
}
</div>    
        {isShow && <Card style={{ marginTop: '2rem',width:"50%" }}>
        <CardContent>
            <div style={{ display: 'flex', alignItems: 'center', gap: '3rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' ,width:"400px"}}>
                    <p style={{ fontFamily: 'IranSans-Bold',width:"200px",marginTop:"10px" }}>انتخاب درگاه آنلاین   </p>
                    <FormControl  style={{width:"400px"}} >
                    <InputLabel id="demo-simple-select-label">درگاه آنلاین </InputLabel>
                    <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={gate}
                    onChange={onChangeHandler}
                    >
                    <MenuItem value={'PAYPING'}>پی پینگ</MenuItem>
                    <MenuItem value={'LIMOOME_ZIFY'}>زیفای</MenuItem>
                    <MenuItem value={'LIMOOME_SAMAN'}>سامان</MenuItem>
                    <MenuItem value={'LIMOSOFT_PAYPING'}>LIMOSOFT پی پینگ</MenuItem>
                    <MenuItem value={'SIBDIET_PAYPING'}>SIBDIET پی پینگ</MenuItem>
                    </Select>
                </FormControl>
                </div>
        
            </div>
        </CardContent>
        <CardActions style={{ direction: 'ltr' }}>
            <Button onClick={() => setGateWay()} style={{ marginLeft: '1rem' }} variant="contained" color="secondary">
                ثبت
            </Button>
        </CardActions>
    </Card>          }
    </div>
    )
}